import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { PaginationModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductRelationState from "@dana/Store/Data/ProductRelations/WhereUsedState";
import { Draft } from "immer";
import BillToMaterialState from "@dana/Store/Data/ProductRelations/BillToMaterialState";

const initialState: BillToMaterialState = {
    productId: "",
    parts: [],
    pagination: {} as PaginationModel,
    relation: "BOM",
    isLoading: false
};

const billToMaterialStateImmerReducer = createTypedReducerWithImmer(initialState, {
    "BeginLoadBillToMaterialProducts": (draft: Draft<BillToMaterialState>, action: { isLoading: boolean }) => {
          draft = { ...initialState, isLoading: true };
      
          return draft;
    },
    "CompleteLoadBillToMaterialProducts": (draft: Draft<BillToMaterialState>, action: { productId: string, products: ProductModel[], pagination: PaginationModel }) => {

        draft = {
            ...initialState,
            isLoading: false,
            productId: action?.productId,
            parts: action?.products,
            pagination: action?.pagination,
        };
        return draft;
    },
    "FailedLoadBillToMaterialProducts": (draft: Draft<BillToMaterialState>, action: { products: ProductModel[], total: number }) => {
         draft = { ...initialState, isLoading: false };
          return draft;
    }
});

(reducers as any).billToMaterialState = billToMaterialStateImmerReducer;

type BillToMaterialReducers = {
    billToMaterialState: typeof billToMaterialStateImmerReducer;
};

export type BillToMaterialActions = Parameters<BillToMaterialReducers[keyof BillToMaterialReducers]>[1] | AnyAction;

